import { render, staticRenderFns } from "./WarehouseUsersTable.vue?vue&type=template&id=87b00c74&scoped=true"
import script from "./WarehouseUsersTable.vue?vue&type=script&lang=js"
export * from "./WarehouseUsersTable.vue?vue&type=script&lang=js"
import style0 from "./WarehouseUsersTable.vue?vue&type=style&index=0&id=87b00c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b00c74",
  null
  
)

export default component.exports